export default __webpack_public_path__ + "static/media/duracion.15b82677.svg";